import type { DashboardSnapshot } from "../../lib/dashboard";
import { formatCompactCurrency } from "../../lib/dashboard";

export function AdvisorContextRail({
  contextCopy,
  snapshot,
}: {
  contextCopy: { description: string; title: string };
  snapshot: DashboardSnapshot;
}) {
  return (
    <div className="space-y-6" data-slot="advisor-workspace-content">
      <section className="space-y-4">
        <div className="space-y-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            Financial inputs
          </p>
          <p className="text-sm leading-6 text-muted-foreground">
            What the advisor is using right now.
          </p>
        </div>
        <dl className="space-y-3 rounded-[1.5rem] bg-background/70 p-4 text-sm">
          <ContextRow label="Target area" value={snapshot.targetArea} />
          <ContextRow label="Timeline" value={snapshot.timeline} />
          <ContextRow label="Housing" value={snapshot.housingSituation} />
          <ContextRow
            label="Household income"
            value={formatCompactCurrency(snapshot.householdIncome)}
          />
          <ContextRow
            label="Savings"
            value={formatCompactCurrency(snapshot.savings)}
          />
        </dl>
      </section>

      <section className="space-y-3">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
          Current guidance
        </p>
        <div className="rounded-[1.5rem] bg-background/70 p-4">
          <h3 className="text-lg font-semibold leading-snug text-foreground">
            {contextCopy.title}
          </h3>
          <p className="mt-2 text-sm leading-6 text-muted-foreground">
            {contextCopy.description}
          </p>
        </div>
      </section>
    </div>
  );
}

function ContextRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between gap-4">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="font-medium text-foreground">{value}</dd>
    </div>
  );
}
